module.exports = new __parcel__URL__("clover.296ea840.svg").toString();